import { useEffect, useState } from "react";
import { CgSpinner } from "react-icons/cg";
import { IoMdClose } from "react-icons/io";
import React from "react";
import { useDispatch } from "react-redux";
import { setAppError } from "../../../../../store/userSlice";
import nodeinstance from "../../../../../nodeInstance";
import IdlePopUp_New from "./IdleconfrimpopUp";
import Not_Return_PopUp from "./NotreturnPopUp";

export default function ErePopup({
  PopUp,
  setPopUp,
  popUpData,
  setTrigger,
  trigger,
  routeType,
  isEdit,
  onEre,
  mainData,
  Cancelshow,
  issuedState,
}) {
  console.log("Page data log to be printed in the console", popUpData);
  const [loading, setLoading] = useState(false);
  const [duration, setDuration] = useState("");
  const handleDurationChange = (e) => {
    setDuration(e.target.value);
  };
  const [file, setFile] = useState();
  const [selectedOption, setSelectedOption] = useState({
    sla_borne: "",
    sla_paybale: "",
    client_borne: "",
    client_paybale: "",
    employee_borne: "",
    employee_paybale: "",
    emergency_leave_status: "",
  });
  const [selectedOptionMain, setSelectedOptionMain] = useState({});
  const [amount, setAmount] = useState("");
  const handleAmountChange = (e) => {
    setAmount(e.target.value);
  };
  const handleOptionChangeMain = (event) => {
    const { name, value } = event.target;
    setSelectedOptionMain((prevSelectedOption) => ({
      ...prevSelectedOption,
      [name]: value,
    }));
  };
  console.log("popUpData..........", popUpData);
  const handleOptionChange = (event) => {
    const { name, value } = event.target;
    setSelectedOption((prevSelectedOption) => ({
      ...prevSelectedOption,
      [name]: value,
    }));
  };
  const [daysUntilExpiry, setDaysUntilExpiry] = useState(null);

  const [data, setData] = useState();

  const response = async () => {
    const endPoint =
      routeType === "Emergency_leave"
        ? `/ere/getDetails/${popUpData?.candidate_id}`
        : routeType === "Annual_Vacation"
          ? `/employeeAnnualvacation/getEmpDetails/${popUpData?.candidate_id}`
          : "";

    try {
      const res = await nodeinstance.get(`${endPoint}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (res.status === 200) {
        console.log("Node js log for reference", res);
        setData(res?.data?.data);
      }
    } catch (error) {
      console.log("error.........", error);
      dispatch(
        setAppError({
          msg: "failed to get the data",
        })
      );
    }
  };
  console.log("Data to be seen from response", data);
  useEffect(() => {
    const calculateDaysUntilExpiry = () => {
      const expiryDate = popUpData?.iqama_expiry_date_g
        ? new Date(popUpData?.iqama_expiry_date_g)
        : new Date();
      const today = new Date();

      const timeDifference = expiryDate - today; // Difference in milliseconds
      const daysDifference = Math.ceil(timeDifference / (1000 * 60 * 60 * 24)); // Convert to days and round up

      setDaysUntilExpiry(daysDifference);
    };

    calculateDaysUntilExpiry();
    if (isEdit) {
      console.log("successs.........");
      response();
    }
  }, []);

  const token = localStorage.getItem("nodeToken");

  const dispatch = useDispatch();

  const [exitBefore, setExitBefore] = useState("");
  const [entryBefore, setEntryBefore] = useState("");

  const handleexitBeforeChange = (e) => {
    setExitBefore(e.target.value);
  };

  const handleentryBefore = (e) => {
    setEntryBefore(e.target.value);
  };
  console.log("selectedOption to be printed here", selectedOption);
  const onSubmit = async () => {
    if (isEdit) {
      try {
        const endPoint =
          routeType === "Emergency_leave"
            ? "/ere/issueEre"
            : routeType === "Annual_Vacation"
              ? "/employeeAnnualvacation/issueEre"
              : "";

        const formData = new FormData();
        formData.append("file", file);
        if (routeType === "Annual_Vacation") {
          formData.append("annual_vacation_status", "ERE ISSUED");
        }
        formData.append("emergency_leave_status", "ERE ISSUED");
        formData.append("exit_before_date", exitBefore);
        if (entryBefore != "") {
          formData.append("entry_before_date", entryBefore);
        }
        formData.append("employee_id", popUpData?.candidate_id);
        const response = await nodeinstance.put(`${endPoint}`, formData, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        });
        if (response.status === 200) {
          setPopUp(false);
          setTrigger(!trigger);
          dispatch(
            setAppError({
              msg: "Updated successfully...",
              color: "success",
            })
          );
        }
      } catch (error) {
        console.log("error.......", error);
        dispatch(
          setAppError({
            msg: "failed",
          })
        );
      }
      return;
    } else {
      if (amount === "") {
        dispatch(
          setAppError({
            msg: "Total Amount field should not be empty",
            // color: "success",
          })
        );
        return;
      }
      if (duration > daysUntilExpiry) {
        dispatch(
          setAppError({
            msg: "Duration is more then iqama expiry days.",
          })
        );
        return;
      }
      const routeSpecificFields =
        routeType === "Emergency_leave"
          ? { emergency_leave_status: "ON ERE-PAYMENT DONE" }
          : { annual_vacation_status: "ON ERE-ANNUAL VACATION-PAYMENT DONE" };

      const reqObject = {
        ...selectedOptionMain,
        ...routeSpecificFields,
        amount: amount,
        iqama_valid_days_remaining: daysUntilExpiry,
        employee_id: popUpData?.candidate_id,
        employeeduration: duration,

        sla_fees:
          selectedOption.sla_borne != "" && selectedOption.sla_paybale != ""
            ? "BOTH"
            : selectedOption.sla_borne != ""
              ? "BORNE"
              : selectedOption.sla_paybale != ""
                ? "PAYBALE"
                : "",
        employee_fees:
          selectedOption.employee_borne != "" &&
          selectedOption.employee_paybale != ""
            ? "BOTH"
            : selectedOption.employee_borne != ""
              ? "BORNE"
              : selectedOption.employee_paybale != ""
                ? "PAYBALE"
                : "",
        client_fees:
          selectedOption.client_borne != "" &&
          selectedOption.client_paybale != ""
            ? "BOTH"
            : selectedOption.client_borne != ""
              ? "BORNE"
              : selectedOption.client_paybale != ""
                ? "PAYBALE"
                : "",
      };
      const filteredReqObject = Object.fromEntries(
        Object.entries(reqObject).filter(([_, value]) => value !== "")
      );
      const emptyOrUndefinedCount = Object.values(reqObject).filter(
        (value) => value === "" || value === undefined
      ).length;
      console.log(
        "selectedOption to be printed in the console",
        emptyOrUndefinedCount,
        filteredReqObject
      );
      if (emptyOrUndefinedCount > 2) {
        dispatch(
          setAppError({
            msg: "All the fileds are require to proceed.",
            // color: "success",
          })
        );
        return;
      }

      // setLoading(true)
      const endPoint =
        routeType === "Emergency_leave"
          ? "/ere/emergencyLeave"
          : routeType === "Annual_Vacation"
            ? "/employeeAnnualvacation/annualVacation"
            : "";
      console.log("file.........", file);
      try {
        const response = await nodeinstance.put(
          `${endPoint}`,
          filteredReqObject,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        if (response.status === 200) {
          setPopUp(false);
          setTrigger(!trigger);
          dispatch(
            setAppError({
              msg: "Updated successfully...",
              color: "success",
            })
          );
          return;
        }
      } catch (error) {
        console.log("error.....", error);
        dispatch(
          setAppError({
            msg: "Failed to update the status",
          })
        );
      }
    }
  };
  console.log("daysUntilExpiry......", data);

  useEffect(() => {
    setSelectedOptionMain((prevSelectedOption) => ({
      ...prevSelectedOption,
      govt_cost: data?.govt_cost,
      salary: data?.salary,
      ere_type: data?.ere_type,
    }));
    setAmount(data?.amount);
    setDuration(data?.employeeduration);
    setSelectedOption((prevSelectedOption) => ({
      ...prevSelectedOption,
      sla_borne:
        data?.sla_fees === null
          ? ""
          : data?.sla_fees === "BORNE"
            ? "BORNE"
            : data?.sla_fees === "BOTH"
              ? "BORNE"
              : "",
      sla_paybale:
        data?.sla_fees === null
          ? ""
          : data?.sla_fees === "PAYBALE"
            ? "PAYABLE"
            : data?.sla_fees === "BOTH"
              ? "PAYABLE"
              : "",
      client_borne:
        data?.client_fees === null
          ? ""
          : data?.client_fees === "BORNE"
            ? "BORNE"
            : data?.client_fees === "BOTH"
              ? "BORNE"
              : "",
      client_paybale:
        data?.client_fees === null
          ? ""
          : data?.client_fees === "PAYBALE"
            ? "PAYABLE"
            : data?.client_fees === "BOTH"
              ? "PAYABLE"
              : "",
      employee_borne:
        data?.employee_fees === null
          ? ""
          : data?.employee_fees === "BORNE"
            ? "BORNE"
            : data?.employee_fees === "BOTH"
              ? "BORNE"
              : "",
      employee_paybale:
        data?.employee_fees === null
          ? ""
          : data?.employee_fees === "PAYBALE"
            ? "PAYABLE"
            : data?.employee_fees === "BOTH"
              ? "PAYABLE"
              : "",
    }));
  }, [data]);

  const [notReturn, setNotReturn] = useState(false);

  const onEreExtendAPI = async () => {
    if (selectedOption.emergency_leave_status === "") {
      dispatch(
        setAppError({
          msg: "Please select the extension type to proceed.",
        })
      );
      return;
    }
    if (selectedOption.emergency_leave_status === "NOT RETURN FROM ERE") {
      setNotReturn(true);
      return;
    }
    setLoading(true);
    let reqObj;
    reqObj = {
      employee_id: popUpData?.candidate_id,
      emergency_leave_status: selectedOption?.emergency_leave_status,
      annual_vacation_status: selectedOption?.emergency_leave_status,
    };
    const endPoint =
      routeType === "Emergency_leave"
        ? "/ere/updateStatus"
        : routeType === "Annual_Vacation"
          ? "/employeeAnnualvacation/UpdateStatus"
          : "";
    try {
      const response = await nodeinstance.put(`${endPoint}`, reqObj, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (response.status === 200) {
        setPopUp(false);
        setTrigger(!trigger);
        dispatch(
          setAppError({
            msg: "Updated successfully...",
            color: "success",
          })
        );
        setLoading(false);
        return;
      }
    } catch (error) {
      console.log("error........", error);
      dispatch(
        setAppError({
          msg: "Failed while updating ERE-Status",
        })
      );
      setLoading(false);
    }
  };

  const formatISODateToInputDate = (isoDate) => {
    if (!isoDate) {
      return;
    }
    const date = new Date(isoDate);
    // Get the date in YYYY-MM-DD format
    return date.toISOString().split("T")[0];
  };

  const [cancelOpen, setCancelOpen] = useState(false);
  const handleOpenClick = () => {
    setCancelOpen(true);
  };
  console.log(
    "log to be printed in the console for the page..",
    selectedOption
  );
  const handleClearClick = () => {
    setSelectedOption({});
  };
  return (
    <>
      <div
        className={`fixed z-50 top-0 left-0 min-w-full min-h-screen bg-black/50  justify-center items-center ${
          PopUp ? "flex" : "hidden"
        }`}
      >
        <div className="max-w-2xl max-h-[45rem]  w-full h-auto mt-4 rounded-md overflow-scroll bg-white/95 flex  flex-col p-4 relative">
          <div className="flex justify-between w-full">
            <h1
              className="text-md font-semibold cursor-pointer"
              onClick={() => {
                setPopUp(false);
              }}
            >
              <IoMdClose />
            </h1>
          </div>
          {/* First Sheet */}
          <div className="bg-orange-50 p-3 ">
            <div className="flex items-center space-x-8 font-bold">
              <label>PAYROLL & BILLING</label>
            </div>
            <div className="flex gap-2 mb-2 mt-2">
              <label className="pr-2">GOVT. COST:</label>

              <div className="flex gap-5">
                <label className="flex gap-x-1">
                  <input
                    type="radio"
                    name="govt_cost"
                    value="BORNE BY CLIENT"
                    checked={
                      selectedOptionMain?.govt_cost === "BORNE BY CLIENT"
                    }
                    onChange={handleOptionChangeMain}
                    disabled={isEdit}
                  />
                  <p> BORNE BY CLIENT</p>
                </label>

                <label className="flex gap-x-1">
                  <input
                    type="radio"
                    value="BORNE BY SLA"
                    name="govt_cost"
                    checked={selectedOptionMain?.govt_cost === "BORNE BY SLA"}
                    onChange={handleOptionChangeMain}
                    disabled={isEdit}
                  />
                  <p> BORNE BY SLA</p>
                </label>
              </div>
              {/* <p>Selected option: {selectedOption}</p> */}
            </div>
            <div className="flex gap-2">
              <label className="pr-2">SALARY:</label>

              <div className="flex gap-5">
                <label className="flex gap-x-1">
                  <input
                    type="radio"
                    name="salary"
                    value="PAYABLE TO EMPLOYEE"
                    checked={
                      selectedOptionMain?.salary === "PAYABLE TO EMPLOYEE"
                    }
                    onChange={handleOptionChangeMain}
                    disabled={isEdit}
                  />
                  <p> PAYABLE TO EMPLOYEE</p>
                </label>

                <label className="flex gap-x-1">
                  <input
                    type="radio"
                    name="salary"
                    value="NOT PAYABLE TO EMPLOYEE"
                    checked={
                      selectedOptionMain?.salary === "NOT PAYABLE TO EMPLOYEE"
                    }
                    onChange={handleOptionChangeMain}
                    disabled={isEdit}
                  />
                  <p> NOT PAYABLE TO EMPLOYEE</p>
                </label>
              </div>
              {/* <p>Selected option: {selectedOption}</p> */}
            </div>
          </div>
          <br />
          {/* Second face */}
          <div className="bg-orange-50 p-3">
            <div className="flex items-center space-x-2 ">
              <label className="font-bold">ERE TYPE</label>
              <label>
                COUNT OF PAST ERE INSTANCE:{" "}
                {routeType === "Emergency_leave"
                  ? popUpData.Emergency_leave_instance
                  : popUpData.Annual_leave_instance}
              </label>
            </div>
            <div className="flex gap-2 mb-2 mt-2">
              <label className="pr-2">TYPE:</label>

              <div className="flex gap-5">
                <label className="flex gap-x-1">
                  <input
                    type="radio"
                    name="ere_type"
                    value="SINGLE"
                    checked={selectedOptionMain?.ere_type === "SINGLE"}
                    onChange={handleOptionChangeMain}
                    disabled={isEdit}
                  />
                  <p> SINGLE</p>
                </label>

                <label className="flex gap-x-1">
                  <input
                    type="radio"
                    name="ere_type"
                    value="MULTIPLE"
                    checked={selectedOptionMain?.ere_type === "MULTIPLE"}
                    onChange={handleOptionChangeMain}
                    disabled={isEdit}
                  />
                  <p> MULTIPLE</p>
                </label>
              </div>
              {/* <p>Selected option: {selectedOption}</p> */}
            </div>

            <div className="flex flex-wrap items-center">
              <label className="mr-2">DURATION:</label>
              <input
                type="number"
                className={`input input-sm h-8 max-w-xs 
                          input-bordered focus:outline-none uppercase`}
                required
                value={duration}
                onChange={handleDurationChange}
                disabled={isEdit}
              />
              <label className="block font-xs uppercase ml-2 text-xs">
                IQAMA Valid days remaining: <br /> {daysUntilExpiry} Days
              </label>
            </div>
          </div>
          <br />
          <div className="bg-orange-50 p-3">
            <div className="flex items-center justify-end space-x-2 mt-1">
              {/* <label className="font-bold mt-4">FEES</label> */}
              <button
                className="bg-red px-4 py-2 text-sm rounded hover:bg-gray-300 text-white"
                onClick={() => {
                  handleClearClick();
                }}
                disabled={isEdit}
              >
                Clear Filter
              </button>
            </div>
            <div className="grid grid-cols-4 gap-4">
              {/* Client */}
              <div>
                <label className="block font-bold">Client</label>
                <label className="flex items-center gap-x-2 mt-2">
                  <input
                    type="radio"
                    name="client_borne"
                    value="BORNE"
                    onChange={handleOptionChange}
                    checked={selectedOption?.client_borne === "BORNE"}
                    disabled={
                      selectedOption?.sla_borne === "BORNE" ||
                      selectedOption?.employee_borne === "BORNE" ||
                      selectedOption?.employee_paybale === "PAYABLE" ||
                      isEdit
                    }
                  />
                  BORNE
                </label>
                <label className="flex items-center gap-x-2 mt-2">
                  <input
                    type="radio"
                    name="client_paybale"
                    value="PAYABLE"
                    onChange={handleOptionChange}
                    checked={selectedOption?.client_paybale === "PAYABLE"}
                    disabled={
                      selectedOption?.sla_borne === "BORNE" ||
                      selectedOption?.employee_borne === "BORNE" ||
                      selectedOption?.sla_paybale === "PAYABLE" ||
                      selectedOption?.employee_paybale === "PAYABLE" ||
                      isEdit
                    }
                  />
                  PAYABLE/PAID
                </label>
              </div>

              {/* SLA */}
              <div>
                <label className="block font-bold">SLA</label>
                <label className="flex items-center gap-x-2 mt-2">
                  <input
                    type="radio"
                    name="sla_borne"
                    value="BORNE"
                    onChange={handleOptionChange}
                    checked={selectedOption?.sla_borne === "BORNE"}
                    disabled={
                      selectedOption?.client_borne === "BORNE" ||
                      selectedOption?.employee_borne === "BORNE" ||
                      isEdit
                    }
                  />
                  BORNE
                </label>
                <label className="flex items-center gap-x-2 mt-2">
                  <input
                    type="radio"
                    name="sla_paybale"
                    value="PAYABLE"
                    onChange={handleOptionChange}
                    checked={selectedOption?.sla_paybale === "PAYABLE"}
                    disabled={
                      selectedOption?.client_paybale === "PAYABLE" ||
                      selectedOption?.employee_paybale === "PAYABLE" ||
                      isEdit
                    }
                  />
                  PAYABLE/PAID
                </label>
              </div>

              {/* Employee */}
              <div>
                <label className="block font-bold">Employee</label>
                <label className="flex items-center gap-x-2 mt-2">
                  <input
                    type="radio"
                    name="employee_borne"
                    value="BORNE"
                    onChange={handleOptionChange}
                    checked={selectedOption?.employee_borne === "BORNE"}
                    disabled={
                      selectedOption?.client_borne === "BORNE" ||
                      selectedOption?.sla_borne === "BORNE" ||
                      selectedOption?.client_paybale === "PAYABLE" ||
                      isEdit
                    }
                  />
                  BORNE
                </label>
                <label className="flex items-center gap-x-2 mt-2">
                  <input
                    type="radio"
                    name="employee_paybale"
                    value="PAYABLE"
                    onChange={handleOptionChange}
                    checked={selectedOption?.employee_paybale === "PAYABLE"}
                    disabled={
                      selectedOption?.client_borne === "BORNE" ||
                      selectedOption?.sla_borne === "BORNE" ||
                      selectedOption?.sla_paybale === "PAYABLE" ||
                      selectedOption?.client_paybale === "PAYABLE" ||
                      isEdit
                    }
                  />
                  PAYABLE/PAID
                </label>
              </div>
            </div>
          </div>

          <div className="bg-orange-50 p-3">
            <div className="flex items-center space-x-2 ">
              <label className="font-bold">TOTAL AMOUNT : </label>
              {/* <label>COUNT OF PAST ERE INSTANCE: 1</label> */}
              <input
                type="number"
                name="amount"
                className={`input input-sm h-8 max-w-xs  w-full 
                      input-bordered focus:outline-none uppercase mb-2 mt-2`}
                required="er"
                value={amount}
                onChange={handleAmountChange}
                disabled={isEdit}
                // onChange={}
              />
            </div>
          </div>

          <br />
          {isEdit === true ? (
            <div className="bg-orange-50 p-3">
              <div className="items-center space-x-2">
                <label className="font-bold">ISSUE ERE</label>
              </div>
              <div className="flex align-center gap-8 mb-5">
                <p>EXIT BEFORE</p>
                <input
                  type="date"
                  id="field2"
                  className={`input input-xl h-8 max-w-xl input-bordered focus:outline-none uppercase`}
                  required
                  min={popUpData.demobilization_date.split("T")[0]}
                  value={
                    exitBefore
                      ? exitBefore
                      : data?.exit_before_date
                        ? formatISODateToInputDate(data?.exit_before_date)
                        : ""
                  }
                  onChange={handleexitBeforeChange}
                  disabled={onEre || !issuedState}
                />
              </div>
              <div className="flex align-center gap-8">
                <p>ENTRY BEFORE</p>
                <input
                  type="date"
                  id="field2"
                  className="input input-xl h-8 max-w-xl input-bordered focus:outline-none uppercase"
                  required
                  min={exitBefore}
                  max={popUpData.iqama_expiry_date_g}
                  value={
                    entryBefore
                      ? entryBefore
                      : data?.entry_before_date
                        ? formatISODateToInputDate(
                            data?.entry_before_date || ""
                          )
                        : ""
                  }
                  onChange={handleentryBefore}
                  disabled={onEre || !issuedState}
                />
              </div>
              {onEre || !issuedState ? (
                ""
              ) : (
                <>
                  <input
                    type="file"
                    className="file-input file-input-bordered w-1/2 mt-2"
                    onChange={(e) => setFile(e.target.files[0])}
                    required
                    accept="application/xls, application/xlsx"
                  />
                  <h1>
                    <span className="text-red">
                      (* File type should be .PDF)
                    </span>
                  </h1>
                </>
              )}
            </div>
          ) : (
            ""
          )}
          <br />
          {onEre ? (
            <div className="bg-orange-50 p-3">
              <div className="flex gap-2 mb-4 mt-4">
                <label className="pr-2">CHANGE STATUS:</label>

                <div className="flex gap-5">
                  <label className="flex gap-x-1">
                    <input
                      type="radio"
                      value="ERE EXTENSION"
                      name="emergency_leave_status"
                      checked={
                        selectedOption?.emergency_leave_status ===
                        "ERE EXTENSION"
                      }
                      onChange={handleOptionChange}
                    />
                    <p> ERE EXTENSION</p>
                  </label>

                  <label className="flex gap-x-1">
                    <input
                      type="radio"
                      value="NOT RETURN FROM ERE"
                      name="emergency_leave_status"
                      checked={
                        selectedOption?.emergency_leave_status ===
                        "NOT RETURN FROM ERE"
                      }
                      onChange={handleOptionChange}
                    />
                    <p> NOT RETURN FROM ERE</p>
                  </label>
                </div>
              </div>
            </div>
          ) : (
            ""
          )}
          <div className="flex w-full">
            <div className="w-full flex flex-col gap-3">
              {onEre ? (
                <div className="flex gap-3 w-full justify-center">
                  <button
                    className="p-3 bg-red text-white rounded-md w-full max-w-xs m-2 my-4 flex gap-3 justify-center items-center text-sm"
                    onClick={() => {
                      onEreExtendAPI();
                    }}
                    // disabled={issuedState}
                  >
                    <p>Submit</p>
                    {loading ? <CgSpinner className="animate-spin" /> : ""}
                  </button>
                </div>
              ) : (
                <div className="flex gap-3 w-full justify-center">
                  <button
                    className="p-3 bg-red text-white rounded-md w-full max-w-xs m-2 my-4 flex gap-3 justify-center items-center text-sm"
                    onClick={() => onSubmit()}
                    // disabled={issuedState}
                  >
                    <p>Submit</p>
                    {loading ? <CgSpinner className="animate-spin" /> : ""}
                  </button>
                </div>
              )}
            </div>
            <div className="w-full flex flex-col gap-3">
              <div className="flex gap-3 w-full justify-center">
                <button
                  className="p-3 bg-black text-white rounded-md w-full max-w-xs m-2 my-4 flex gap-3 justify-center items-center text-sm"
                  onClick={() => {
                    // setPopUp(false);
                    handleOpenClick();
                    // cancelRequest();
                  }}
                  // disabled={onEre}
                  // disabled={data?.entry_before_date === null}
                >
                  {popUpData?.emergency_leave_status === "ON ERE" ||
                  popUpData.Annual_vacation_status ===
                    "ON ERE-ANNUAL VACATION" ? (
                    <p>{"Returned from ERE"} </p>
                  ) : (
                    <p>
                      {!Cancelshow ||
                      !issuedState ||
                      popUpData?.emergency_leave_status ===
                        "ON ERE-PAYMENT DONE" ||
                      popUpData.Annual_vacation_status ===
                        "ON ERE-ANNUAL VACATION-PAYMENT DONE"
                        ? "CANCEL REQUEST"
                        : "Returned from ERE"}{" "}
                    </p>
                  )}
                  {/* {loading ? <CgSpinner className="animate-spin" /> : ""} */}
                </button>
              </div>
            </div>
            {cancelOpen ? (
              <IdlePopUp_New
                cancelOpen={cancelOpen}
                setCancelOpen={setCancelOpen}
                setPopUp={setPopUp}
                popUpData={popUpData}
                trigger={trigger}
                setTrigger={setTrigger}
                routeType={routeType}
                issuedState={issuedState}
                showDate={
                  popUpData.emergency_leave_status != null ||
                  popUpData.Annual_vacation_status != null
                    ? true
                    : false
                }
              />
            ) : (
              ""
            )}
            {notReturn ? (
              <Not_Return_PopUp
                notReturn={notReturn}
                setNotReturn={setNotReturn}
                popUpData={popUpData}
                trigger={trigger}
                setTrigger={setTrigger}
                setPopUp={setPopUp}
                routeType={routeType}
              />
            ) : (
              ""
            )}
          </div>
        </div>
      </div>
    </>
  );
}
